import { useEffect } from "react";
import { useRawTable } from "../../hooks";

export default function Module_ElderlyHealthCheckup_DateToCheckItemAnalysis({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
}) {
  const { setTbData, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!apiData) return;
    setTbData({
      raw: apiData.sort(function (pre, next) {
        return Number(next.StudyYear) - Number(pre.StudyYear);
      }),
      format: null,
      export: null,
    });
  }, [apiData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
      })}
    </>
  );
}
